import { render, staticRenderFns } from "./PremiumBblEditorOptionsAPI.vue?vue&type=template&id=daf27dbc&scoped=true"
import script from "./PremiumBblEditorOptionsAPI.vue?vue&type=script&lang=js"
export * from "./PremiumBblEditorOptionsAPI.vue?vue&type=script&lang=js"
import style0 from "./PremiumBblEditorOptionsAPI.vue?vue&type=style&index=0&id=daf27dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf27dbc",
  null
  
)

export default component.exports